import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PendingActionsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pending_actions"}/>
}
